import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/subcorridas`, options).then(response => {
    return {
      list: response.data.data, 
      meta: response.data.meta
    };
  });
}

function getMotivoIngresos(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/movimientos_caja/motivosIngreso`, options)
    .then(response => {
      return response.data
    });
}

function getMotivoEgresos(id) {
  const options = {
      headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
      }
  };

  return axios
    .get(`${url}/movimientos_caja/motivosEgreso`, options)
    .then(response => {
        return response.data
    });
}
function addIngreso(movimiento) {
  const payload = jsona.serialize({
    stuff: movimiento,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/movimientos_caja/ingreso`, payload, options)
    .then(response => {
      return response.data;
    });
}
function addEgreso(movimiento) {
  const payload = jsona.serialize({
    stuff: movimiento,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/movimientos_caja/egreso`, payload, options)
    .then(response => {
      return response.data;
    });
}


export default {
  list,
  getMotivoEgresos,
  getMotivoIngresos,
  addIngreso,
  addEgreso
};
